<template>
    <div class="qksm">
        <div class="nogap">
            <p><b>（二）预算测算标准</b></p>
            <p>
                1、人员经费：<reason type="textarea" classname="qksm widest" name="Q21" v-model:value="qksm['Q21']" placeholder="按实际发放计算"></reason>
            </p>
            <p>
                2、一般公用经费：<reason type="textarea" classname="qksm widest" name="Q22" v-model:value="qksm['Q22']" placeholder="按部门实际情况说明"></reason>
            </p>
            <p>
                3、日常业务经费：<reason type="textarea" classname="qksm widest" name="Q23" v-model:value="qksm['Q23']" placeholder="按部门实际情况说明"></reason>
            </p>
            <p>
                4、单项定额经费：<reason type="textarea" classname="qksm widest" name="Q24" v-model:value="qksm['Q24']" placeholder="按部门实际情况说明"></reason>
            </p>
            <p>
                5、社保经费离退休费：<reason type="textarea" classname="qksm widest" name="Q25" v-model:value="qksm['Q25']" placeholder="按部门实际情况说明"></reason>
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm2",
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
            }
        },
        components: {
            reason,
        },
    };

</script>